const styles = {
  centerBoxSx: { display: "flex", justifyContent: "center", mt: 5 },
};

export default styles;
